import styled from 'styled-components';
export const Weekchoice = styled.ul`
    display:flex;
    justify-content: space-between;
    margin-top : calc(100vw*(18/375));
    margin-bottom : calc(100vw*(15/375));
`
export const Weektxt = styled.li`

`

export const DayUncheck = styled.label`
    display: inline-block;
    width: calc(100vw*(37/375));
    height: calc(100vw*(37/375));
    background-color: #ffefce;
    border-radius : 50%;
    text-align : center;
    line-height: calc(100vw*(35/375));
    font-size: calc(100vw*(17/375));
    font-weight: 500;
    color: #ffffff;
`
export const DayCheck = styled.label`
    display: inline-block;
    width: calc(100vw*(37/375));
    height: calc(100vw*(37/375));
    background-color: #ffcf19;
    border-radius : 50%;
    text-align : center;
    line-height: calc(100vw*(35/375));
    font-size: calc(100vw*(17/375));
    font-weight: 500;
    color: #ffffff;
`